import { render, staticRenderFns } from "./VxAutoSuggestModified.vue?vue&type=template&id=eb0225b0&scoped=true"
import script from "./VxAutoSuggestModified.vue?vue&type=script&lang=js"
export * from "./VxAutoSuggestModified.vue?vue&type=script&lang=js"
import style0 from "./VxAutoSuggestModified.vue?vue&type=style&index=0&id=eb0225b0&prod&scoped=true&lang=css"
import style1 from "./VxAutoSuggestModified.vue?vue&type=style&index=1&id=eb0225b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0225b0",
  null
  
)

export default component.exports